import { useEffect } from 'react';
import { useWebPubSub } from '../../contexts/WebPubSubContext';

/**
 * Registers a job-status callback on the app-shell Web PubSub client.
 * Kept as a drop-in replacement for the previous AppSync listener.
 */
function FileStatusListener({ onJobStatusUpdate }) {
    const { subscribe } = useWebPubSub();

    useEffect(() => {
        if (!onJobStatusUpdate || typeof onJobStatusUpdate !== 'function') {
            return undefined;
        }
        return subscribe(onJobStatusUpdate);
    }, [subscribe, onJobStatusUpdate]);

    return null;
}

export default FileStatusListener;
